import characters from "./characters";
import { Entity, Game, GameFlow, SectionType } from "./types";

export const flow: GameFlow = [

    {
        type: SectionType.INTERLUDE,
        screens: [
            {text: {t: "Disclaimer: you have a lot of power here..."},},
            {text: {t: "... so don't fuck around."}},
            {text: {t: "First things first..."}},
            {
               image: "https://images.photowall.com/products/52919/glowing-earth-floating-in-space.jpg?h=699&q=85",
               npcDialog: {person: characters.TheProgenator, dialog: "Would you like to play a game?"},
               userOptionQuestion: {
                prompt: 'What would you like to do?',
                options: [
                    {text: 'Yes', navToFrameUid: 'todo'},
                    {text: 'No', navToFrameUid: 'earth death: uncreated'}
                ]
               }
            },
        ],
    },
    {
      type: SectionType.INTERLUDE,
      screens: [
        {
          uid: 'earth death: uncreated',
          text: {t: "Congratulations dingus :: you've uncreated the earth. \nEverything that's ever existed is now gone. Maybe take five and reconsider your behavior."},
          image: "https://3wisdoms.com/wp-content/uploads/2021/11/empty.jpg"
        },
      ]
    }

]

export const earth: Game = {
    name: 'earth',
    link: 'earth',
    gameFlow: flow
}